import { Inject, Injectable } from "@angular/core";
import { ENVIRONMENT } from "../modules/keycloak.module";
import type { IEnvironment } from "../models/interfaces/environment.interface";
import { Observable } from "rxjs";
import { RetryHttpClient } from "./base/retryable-http.client";

export interface MenuItem {
  key: string;
  isActive: boolean;
}

@Injectable({ providedIn: "root" })
export class MenuService {
  constructor(
    private readonly httpClient: RetryHttpClient,
    @Inject(ENVIRONMENT) private readonly environment: IEnvironment
  ) {}

  getMenu(): Observable<MenuItem[]> {
    return this.httpClient.get<MenuItem[]>(`${this.environment.BASE_URL}/v1/menu`);
  }
}
